import { useRef, useEffect } from "react";
import Swiper from "swiper";
const MovieGallery = ({ urls }) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    if (urls.length > 0) {
      swiperRef.current = new Swiper(".swiper-container", {
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          900: { slidesPerView: 3 },
          600: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        },
      });
    }
  }, [urls]);

  return (
    <div className="movie-gallery">
      <div className="movie-gallery-container">
        <h2 className="movie-ref-title">Gallery</h2>
        <div className="swiper-container movie-gallery-content">
          <div className="swiper-wrapper">
            {urls.map((item, index) => (
              <div className="swiper-slide" key={index}>
                {/* <a href={item}> */}
                <img className="movie-gallery-image" src={item} alt="" />
                {/* </a> */}
              </div>
            ))}
          </div>
          <div className="swiper-button-next"></div>
          <div className="swiper-button-prev"></div>
        </div>
      </div>
    </div>
  );
};

export default MovieGallery;
